import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconForm(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M3 3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v4.5a1 1 0 1 1-2 0V4H5v16h12v-3a1 1 0 1 1 2 0v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3Z"
      />
      <path
        fill="currentColor"
        d="M7 8a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1ZM8 11a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2H8ZM7 16a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1ZM15.707 15.707l6-6a1 1 0 0 0-1.414-1.414l-6 6L14 16l1.707-.293Z"
      />
    </BaseIcon>
  );
}
